<template>
  <div class="opinion">
    <div class="opinion-detail">
      <div class="title">意见反馈</div>
      <div class="english">Feedback</div>
      <div class="out-box">
        <el-form :model="messageForm" label-width="80px" :rules="rules" ref="messageForm" style="text-align:left;">
          <el-form-item label="标题" prop="title" style="margin-top:10px;">
            <el-input v-model.trim="messageForm.title" clearable placeholder="请输入标题" size="small"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email" style="margin-top:10px;">
            <el-input v-model.trim="messageForm.email" clearable placeholder="请输入邮箱" size="small"></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="content" style="margin-top:10px;">
            <el-input type="textarea" :rows="5" v-model.trim="messageForm.content" clearable placeholder="请输入留言内容" size="small" maxlength="1000" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="commitMessage" size="small" style="width:100px;">发送</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseApi from "@/api/base";
import { getStorage } from "@/common/js/localstorage";

export default {
  name: "Opinion",
  data() {
    return {
      schoolId: 0,
      areaId: 0,
      isSchool: true,
      messageForm: {
        org_id: "",
        org_type: "",
        title: "",
        email: "",
        content: ""
      },
      rules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          { validator: this.validateName, trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: this.validateNum, trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入内容", trigger: "blur" },
          { validator: this.validateNum, trigger: "blur" },
        ],
      },
    }
  },
  created() {
    this.getSchoolId();
  },
  methods: {
    // 表单校验规则
    validateName(rule, value, callback) {
      if (!value.trim()) {
        callback(new Error("输入不能为空"));
      } else {
        callback();
      }
    },
    // 先判断是否登录，再判断区域用户还是学校用户，并设置school_id
    getSchoolId() {
      if (getStorage("user")) {
        let data = getStorage("user");
        if (data.area_type == 2) {
          this.schoolId = data.area_id;
          this.isSchool = true;
        } else {
          this.areaId = data.area_id;
          this.isSchool = false;
        }
        this.messageForm.org_id = data.area_id;
        this.messageForm.org_type = data.area_type;
      } else {
        if (getStorage("school")) {
          this.schoolId = getStorage("school").org_id;
          this.messageForm.org_id = getStorage("school").org_id;
          this.messageForm.org_type = getStorage("school").org_type;
        }
      }
    },
    //【前台】提交留言/意见反馈
    commitMessage() {
      this.$refs['messageForm'].validate((valid) => {
        if (valid) {
          baseApi.commitMessage(this.messageForm).then((response) => {
            if (response.data.status == 0) {
              this.$message({
                type: "success",
                message: "发送成功"
              })
              this.messageForm.title = "";
              this.messageForm.email = "";
              this.messageForm.content = "";
            } else {
              console.log(response.data.info.detail);
              this.$message({
                type: "warning",
                message: response.data.info.message,
              });
            }
          });
        } else {
          this.$message({
            type: "warning",
            message: "操作失败",
          });
        }
      })
    }
  }
}
</script>

<style scoped lang="stylus">
.opinion {
  width: 100%;
  min-height: calc(100vh - 144px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .opinion-detail {
    width: 50%;
    padding-top: 80px;
    padding-bottom: 80px;
    box-sizing: border-box;

    .title {
      font-size: 24px;
      font-weight: bold;
    }

    .english {
      color: #9A9A9A;
      margin-top: 20px;
      margin-bottom: 40px;
    }

    .out-box {
      width: 100%;
    }
  }
}
</style>